import { render, staticRenderFns } from "./GroupDigiBoards.vue?vue&type=template&id=1e2a4e2d&scoped=true"
import script from "./GroupDigiBoards.vue?vue&type=script&lang=js"
export * from "./GroupDigiBoards.vue?vue&type=script&lang=js"
import style0 from "./GroupDigiBoards.vue?vue&type=style&index=0&id=1e2a4e2d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e2a4e2d",
  null
  
)

export default component.exports